import { render, staticRenderFns } from "./QuizContentForm.vue?vue&type=template&id=dfd787dc&"
import script from "./QuizContentForm.vue?vue&type=script&lang=ts&"
export * from "./QuizContentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports